// Typelizer digest 61edf4767fa42076006290f419d1ab8f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /c/:company_id/ledger/vat_return/export */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/vat_return/export', {}, options),
    method: 'get',
  }),
}
